import React, { useEffect } from "react";

// Components
import { Table } from "antd";

// Styles
import { CenterContentWrapper, ActionLink, QuantityField } from "./ProductsTable.styles";
import { Link, useParams } from "react-router-dom";
import { Fulfillment } from "@secondcloset/types";
type Product = Fulfillment.Product;
interface Props {
  selectedProducts: Product[];
  requiredParts?: { [key: string]: number };
  handleChangeQuantity: (baseProductID: string, quantity: number) => void;
  handleRemoveComponent: (baseProductID: string) => void;
  isEditing: boolean;
}

const ProductsTable: React.FC<Props> = ({
  selectedProducts,
  requiredParts,
  handleChangeQuantity,
  handleRemoveComponent,
  isEditing,
}) => {
  const params: { organization_id: string } = useParams();
  const { organization_id: organizationID } = params;

  useEffect(() => {
    const quantityHeader = document.getElementsByClassName("ant-table-cell")[3] as HTMLElement;
    quantityHeader.style.textAlign = "center";
    const actionHeader = document.getElementsByClassName("ant-table-cell")[4] as HTMLElement;
    actionHeader.style.textAlign = "center";
  }, []);

  const renderSku = (record: Product) => (
    <Link to={`/organizations/${organizationID}/products/${record.id}`} target="_blank">
      {record.sku}
    </Link>
  );

  const renderSCID = (record: Product) => (
    <Link to={`/organizations/${organizationID}/products/${record.id}`} target="_blank">
      {record.scid || "-"}
    </Link>
  );

  const renderQuantity = (record: Product) => (
    <CenterContentWrapper>
      <QuantityField
        type="number"
        min="0"
        disabled={!isEditing}
        value={requiredParts && Object.keys(requiredParts).includes(record.id) ? requiredParts[record.id] : 1}
        onFocus={(e) => e.target.select()}
        onChange={(e) => handleChangeQuantity(record.id, Number(e.target.value))}
        invalid={
          requiredParts && Object.keys(requiredParts).includes(record.id) ? requiredParts[record.id] === 0 : false
        }
      />
    </CenterContentWrapper>
  );

  const renderAction = (record: Product) => {
    return (
      <CenterContentWrapper>
        <ActionLink disabled={!isEditing} onClick={isEditing ? () => handleRemoveComponent(record.id) : () => {}}>
          Remove
        </ActionLink>
      </CenterContentWrapper>
    );
  };

  const columns = [
    {
      title: "SKU",
      key: "sku",
      render: renderSku,
    },
    {
      title: "SCID",
      key: "scid",
      render: renderSCID,
    },
    {
      title: "Base Product Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Quantity",
      key: "quantity",
      render: renderQuantity,
    },
    {
      title: "Action",
      key: "action",
      render: renderAction,
    },
  ];

  return (
    <Table
      bordered={isEditing}
      columns={columns}
      dataSource={selectedProducts}
      pagination={false}
      rowKey={(record) => record.id}
    />
  );
};

export default ProductsTable;
